export default {
    me: {},
    authenticated: false,
    // urlBack: '',
}